import {FormInput} from "@/components/forms/FormInput.jsx";
import { FormTextarea } from '@/components/forms/FormTextarea.jsx';
import { FormMultipleOptions } from '@/components/forms/FormMultipleOptions.jsx';
import { categoriesOptions } from '@/features/recipes/schema.js';
import { Grid, Box, Stack } from '@mui/joy';
import { FormImages } from '@/components/forms/FormImages';
import { FormTagsInput } from '@/features/tags/components/FormTagsInput';
import { useUploadRecipeImageMutation } from '@/features/recipes/api';

export function DetailsFormTab() {
  return (
    <Stack spacing={3}>
      <FormInput name="name" label="Recipe Name" placeholder="Enter recipe name" />
      <FormTextarea name="description" label="Description" placeholder="Describe your recipe" optional />
      <Stack spacing={{ xs: 3, sm: 2 }} direction={{ xs: 'column', sm: 'row' }}>        
        <FormInput name="url" label="Recipe URL" placeholder="e.g. https://example.com/recipe" optional sx={{ flex: 1 }} />        
        <FormInput name="video_url" label="Video Recipe URL" placeholder="e.g. https://youtube.com/..." optional sx={{ flex: 1 }} />        
      </Stack>
      <FormMultipleOptions name="categories" label="Categories" options={categoriesOptions} />      
      <FormTagsInput name="tags" label="Tags" optional />
      <Box>
        <Grid container spacing={2}>
          <Grid xs={12} sm={4}>
            <FormInput name="servings" label="Servings" type="number" placeholder="e.g. 4" inputProps={{ min: 1 }} />
          </Grid>
          <Grid xs={12} sm={4}>
            <FormInput name="prep_time" label="Prep Time" type="number" placeholder="e.g. 15" inputProps={{ min: 0 }} endDecorator="min" />
          </Grid>
          <Grid xs={12} sm={4}>
            <FormInput name="cook_time" label="Cook Time" type="number" placeholder="e.g. 30" inputProps={{ min: 0 }} endDecorator="min" />
          </Grid>        
        </Grid>
      </Box>
      <FormImages name="images" label="Images" useUploadImageMutation={useUploadRecipeImageMutation} />
    </Stack>
  )
}
